export default {
	namespaced: true,
	state: () => ({
		signInfo: {
			list: [],
			videoModel: {},
			canSign: null, // 是否普通签到
			day: 0,
			dayReward: 0,
			weekReward: 0,
			signAB: 'a', // 签到功能 AB, 'a', 'b', 'c'
			todayInfo: {},
			videoSignStatus: false, // 视频签到状态 false: 未签 true: 已签
			signType: 0, // 签到类型；1：普通签到逻辑 2：回归用户签到逻辑
			businessName: null,
			overBusinessName: null,
		},
		regressTaskList: [], // 签到任务列表
		taskList: [],
		wallet: {
			balance: 0,
			coin: 0,
			limitTaskInfo: {},
			limitTaskTime: 0,
		},
		isShowLimitTip: true, // 是否显示余额专属金提示
		startCountDown: false, // 是否开启专属任务金倒计时
		startCount: false, // 是否开启福利宝箱倒计时
		videoCBConf: {
			pos: '', // 调用激励视频位置；'signVideo': 视频签到；'taskVideo': 任务视频
			param: {}, // 回调方法参数
		},
		calendarConfig: {
			callback: 'window.bridge.onCalendarCallBack',
			method: 'add', // search add delete
			accountName: '快音APP',
			endDay: '',
			note: '打开快音APP，【福利页】签到即可领取',
			startDay: '',
			title: '【快音签到提醒】金币奖励可领取，连续签到领大奖',
			ruleType: 'week',
		},
		isAutoOpenCalendar: false,
		leavePageTime: 0,
		leaveTimer: null,
		leaveRewardTime: 5000,
		modalConf: {},
		overBusinessName: '',
		treasureTaskList: [],
		treasureBox: null,
		treasureTime: 0,
		coinRatePromote: {}, // 金币汇率
		coinExchangeRate: '', // 普通金币汇率
	}),
	mutations: {
		setTaskList(state, data) {
			const { task_list_new } = data;
			const cloneTask = JSON.parse(JSON.stringify(state.taskList));
			const tabTypeCollapseMap = new Map();

			cloneTask.forEach((item) => {
				tabTypeCollapseMap.set(item.tab_type, item.collapse);
			});

			state.taskList = task_list_new && [...task_list_new];
			state.taskList.forEach((item) => {
				if (item.task_show_num && (tabTypeCollapseMap.get(item.tab_type) === undefined || tabTypeCollapseMap.get(item.tab_type))) {
					item.collapse = true;
				} else {
					item.collapse = false;
				}
			});
		},
		setTreasureTaskList(state, data) {
			state.treasureTaskList = [...data];
		},
		setTreasureBox(state, data) {
			state.treasureBox = data;
		},
		setTreasureTime(state, data) {
			state.treasureTime = data;
		},
		setWallet(state, data) {
			const {
				profile: { balance_amount: balance, coin_amount: coin, coin_exchange_balance },
				cash_reward_task_info: limitTaskInfo,
			} = data;

			let limitTaskTime = 0;

			if (limitTaskInfo) {
				limitTaskTime = limitTaskInfo.expire_time - limitTaskInfo.time;
			}
			state.coinExchangeRate = coin_exchange_balance;
			state.wallet = Object.assign(state.wallet, {
				balance,
				coin: +coin,
				limitTaskInfo: limitTaskInfo || {},
				limitTaskTime,
			});
		},
		setSignInfo(state, data) {
			const {
				sign_info: {
					can_sign: canSign,
					list,
					video_model: videoModel,
					today: day,
					today_reward: dayReward,
					reward_count: weekReward,
					today_info: todayInfo,
					sign_ab: signAB,
					sign_type: signType,
					business_name: businessName,
					over_business_name: overBusinessName,
				},
			} = data;

			// 处理签到列表
			list.forEach((item) => {
				const { has_video_sign, sign_status, video_sign_status, sign_reward_type, video_sign_reward_type } = item;
				item.status = 0; // 控制签到列表项具体显示；1：普通签到项 2：视频签到项 3：已签项 4: 现金奖励签到项 5: 漏签项

				// 用户签到已领的具体数值
				if (video_sign_status && video_sign_reward_type === 'coin') {
					item.curReward = item.sign_reward + item.video_sign_reward;
				} else {
					item.curReward = item.sign_reward;
				}

				// 对现金数字转换为元
				if (sign_reward_type === 'balance') {
					item.sign_reward = (item.sign_reward / 100).toFixed(2);
				}

				if (video_sign_reward_type === 'balance') {
					item.video_sign_reward = (item.video_sign_reward / 100).toFixed(2);
				}

				if (parseInt(item.day) === parseInt(day) && sign_status && has_video_sign && !video_sign_status) {
					item.status = 2; // 看视频签到
				} else if (item.sign_miss_status && item.sign_miss_status === 1) {
					item.status = 5; // 漏签
				} else if (!sign_status) {
					item.status = 1; // 普通签到
				} else {
					item.status = 3; // 签到完成
				}

				if (item.status !== 3 && item.status !== 5 && (video_sign_reward_type === 'balance' || sign_reward_type === 'balance')) {
					item.status = 4; // 奖励类型为现金的可签到状态
				}
			});

			// 处理今日签到信息 现金数字转换为元
			if (todayInfo.sign_reward_type === 'balance') {
				todayInfo.sign_reward = (todayInfo.sign_reward / 100).toFixed(2);
			}

			if (todayInfo.video_sign_reward_type === 'balance') {
				todayInfo.video_sign_reward = (todayInfo.video_sign_reward / 100).toFixed(2);
			}

			state.signInfo = Object.assign(state.signInfo, {
				list,
				videoModel,
				canSign,
				day: Number(day),
				dayReward,
				weekReward,
				todayInfo,
				signAB,
				videoSignStatus: !!todayInfo.video_sign_status,
				signType,
				businessName: businessName || null,
				overBusinessName: overBusinessName || null,
			});
		},
		setRegressTaskList(state, data) {
			const { regress_task_list: regressTaskList } = data;

			if (regressTaskList && regressTaskList.length) {
				state.regressTaskList = [regressTaskList[0]];
			} else {
				state.regressTaskList = [];
			}
		},
		setCanSign(state, data) {
			state.signInfo = Object.assign(state.signInfo, {
				canSign: data,
			});
		},
		setVideoSignStatus(state, data) {
			state.signInfo = Object.assign(state.signInfo, {
				videoSignStatus: data,
			});
		},
		// 更新今日签到项显示状态(1：普通签到；2：视频签到；3：已签到)，并且返回当前项；
		setSignStatus(state, data) {
			const { list, day } = state.signInfo;
			let index, signObj;

			signObj = list.filter((item, i) => {
				if (item.day === day) {
					index = i;
					return item;
				}
			});
			[signObj] = signObj;

			if (data) {
				// 视频签到更新
				const videoSignReward = signObj.video_sign_reward_type === 'coin' ? signObj.video_sign_reward : 0;

				signObj.status = +data;
				signObj.curReward = signObj.sign_reward + videoSignReward;
			} else {
				// 普通签到更新
				if (signObj.has_video_sign && !signObj.video_sign_status) {
					if (signObj.video_sign_reward_type === 'balance') {
						signObj.status = 4;
					} else {
						signObj.status = 2;
					}
				} else {
					signObj.status = 3;
				}
			}

			list[index] = signObj;
		},
		updateTask(state, data) {
			const { tab_type, task_id, task_pos } = data;
			let cloneTask;

			if (task_pos === 'treasure_box') {
				cloneTask = JSON.parse(JSON.stringify(state.treasureTaskList));

				for (let task of cloneTask) {
					if (task.task_id === task_id) {
						task = Object.assign(task, data);
						break;
					}
				}

				state.treasureTaskList = cloneTask;
			} else {
				cloneTask = JSON.parse(JSON.stringify(state.taskList));

				for (let parent of cloneTask) {
					if (+parent.tab_type === +tab_type) {
						for (let task of parent.task_list) {
							if (task.task_id === task_id) {
								task = Object.assign(task, data);
								break;
							}
						}
						break;
					}
				}

				state.taskList = cloneTask;
			}
		},
		setVideoCBConf(state, data) {
			state.videoCBConf = Object.assign(data);
		},
		setIsAutoOpenCalendar(state, data) {
			state.isAutoOpenCalendar = data;
		},
		setLeaveTime(state, data) {
			state.leavePageTime = data;
		},
		setLeaveTimer(state, data) {
			state.leaveTimer = data;
		},
		setLeaveRewardTime(state, data) {
			state.setLeaveRewardTime = data;
		},
		updateLimitTaskTime(state, data) {
			const { limitTaskTime } = data;
			state.wallet = Object.assign(state.wallet, { limitTaskTime });
		},
		changeStartCountDown(state, data) {
			state.startCountDown = data;
		},
		changeStartCount(state, data) {
			state.startCount = data;
		},
		setModalConf(state, data) {
			state.modalConf = data;
		},
		setIsShowLimitTip(state, data) {
			state.isShowLimitTip = data;
		},
		setOverBusinessName(state, data) {
			state.overBusinessName = data.overBusinessName || '';
		},
		setChest(state, data) {
			state.chest = data;
		},
		changeTaskCollapse(state, tabType) {
			const cloneTask = JSON.parse(JSON.stringify(state.taskList));

			cloneTask.forEach((item) => {
				if (+item.tab_type === +tabType) {
					item.collapse = !item.collapse;
				}
			});

			state.taskList = cloneTask;
		},
		setCoinRatePromote(state, data) {
			state.coinRatePromote = data;
		},
	},
	actions: {},
	getters: {
		taskList: (state) => {
			return state.taskList;
		},
		treasureTaskList: (state) => {
			return state.treasureTaskList;
		},
		treasureBox: (state) => {
			return state.treasureBox;
		},
		treasureTime: (state) => {
			return state.treasureTime;
		},
		wallet: (state) => {
			return state.wallet;
		},
		signInfo: (state) => {
			return state.signInfo;
		},
		videoCBConf: (state) => {
			return state.videoCBConf;
		},
		calendarConfig: (state) => {
			return state.calendarConfig;
		},
		isAutoOpenCalendar: (state) => {
			return state.isAutoOpenCalendar;
		},
		leavePageTime: (state) => {
			return state.leavePageTime;
		},
		leaveRewardTime: (state) => {
			return state.leaveRewardTime;
		},
		startCountDown: (state) => {
			return state.startCountDown;
		},
		startCount: (state) => {
			return state.startCount;
		},
		modalConf: (state) => {
			return state.modalConf;
		},
		isShowLimitTip: (state) => {
			return state.isShowLimitTip;
		},
		overBusinessName: (state) => {
			return state.overBusinessName;
		},
		curSignTask: (state) => {
			if (state.regressTaskList.length) return state.regressTaskList[0];
			return null;
		},
		coinRatePromote: (state) => {
			return state.coinRatePromote;
		},
		coinExchangeRate: (state) => {
			return state.coinExchangeRate;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Welfare/modules/task.js